// Grade 2026/02 transcrita dos PDFs da UNIFENAS-BH.
// O campo sourcePdf preserva as tabelas e o texto extraídos, inclusive escalas de ambulatório.
// As datas dos blocos vêm do calendário já cadastrado em ../data.js; os PDFs de horário não as informam.
// A rotação A/B/C foi confirmada pela turma; ainda faltam os PDFs das grades dos blocos 2–4.
import sourcePdf from "./sources/period5.json";
const periodDataset = {
  label: "5º período",
  syndromes: {
  "pediatricas1": {
    "name": "Síndromes Pediátricas I",
    "short": "Pediátricas I"
  },
  "cardiovasculares": {
    "name": "Síndromes Cardiovasculares",
    "short": "Cardio"
  },
  "respiratorias": {
    "name": "Síndromes Respiratórias",
    "short": "Respiratórias"
  },
  "digestorias": {
    "name": "Síndromes Digestórias",
    "short": "Digestórias"
  }
},
  blocks: [
  {
    "number": 1,
    "start": "2026-07-28",
    "end": "2026-08-21",
    "label": "1º bloco"
  },
  {
    "number": 2,
    "start": "2026-08-24",
    "end": "2026-09-25",
    "label": "2º bloco"
  },
  {
    "number": 3,
    "start": "2026-09-28",
    "end": "2026-10-30",
    "label": "3º bloco"
  },
  {
    "number": 4,
    "start": "2026-11-03",
    "end": "2026-12-04",
    "label": "4º bloco"
  }
],
  defaultRotations: {
  "A": {
    "1": "pediatricas1", "2": "cardiovasculares", "3": "respiratorias", "4": "digestorias"
  },
  "B": {
    "1": "pediatricas1", "2": "respiratorias", "3": "digestorias", "4": "cardiovasculares"
  },
  "C": {
    "1": "pediatricas1", "2": "digestorias", "3": "cardiovasculares", "4": "respiratorias"
  }
},
  baseSchedule: {
  "pediatricas1": {
    "2": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Jordane",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Jordane",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "3": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Erica",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Paulo",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Wilton",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ricardo N",
          "location": "105",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Erica",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Paulo",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Wilton",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ricardo N",
          "location": "105",
          "kind": "gt"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Liliane A",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Luana",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Dourado",
          "location": "patologia",
          "kind": "pl"
        }
      },
      "pm2": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Luana",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Dourado",
          "location": "patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Liliane A",
          "location": "Simulação",
          "kind": "th"
        }
      }
    },
    "1": {
      "am1": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Eliana Horta",
          "location": "",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Eliana Horta",
          "location": "",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Eliana Horta",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Eliana Horta",
          "location": "",
          "kind": "pe"
        }
      },
      "am2": {
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "alterado",
          "location": "",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "alterado",
          "location": "",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "alterado",
          "location": "",
          "kind": "class"
        },
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "alterado",
          "location": "",
          "kind": "class"
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Erica",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Paulo",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Wilton",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ricardo N",
          "location": "105",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Erica",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Paulo",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Wilton",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ricardo N",
          "location": "105",
          "kind": "gt"
        }
      }
    },
    "4": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "5": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    }
  }
},
  baseScheduleByLetter: {
  "pediatricas1": {
    "A": {
      "2": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Jordane",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Jordane",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Erica",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Wilton",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ricardo N",
            "location": "105",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Erica",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Wilton",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ricardo N",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Liliane A",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luana",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Dourado",
            "location": "patologia",
            "kind": "pl"
          }
        },
        "pm2": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luana",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Dourado",
            "location": "patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Liliane A",
            "location": "Simulação",
            "kind": "th"
          }
        }
      },
      "1": {
        "am1": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          }
        },
        "am2": {
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          },
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Erica",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Wilton",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ricardo N",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Erica",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Wilton",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ricardo N",
            "location": "105",
            "kind": "gt"
          }
        }
      },
      "4": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "5": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      }
    },
    "B": {
      "1": {
        "am1": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Daniela",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Freitas",
            "location": "patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rosiane",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rosiane",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Daniela",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Freitas",
            "location": "patologia",
            "kind": "pl"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rosiane",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rosiane",
            "location": "Simulação",
            "kind": "th"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Gláucia",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Alexandre",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Jaílson",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luiza A",
            "location": "105",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Gláucia",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Alexandre",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Jaílson",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luiza A",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "5": {
        "am1": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "CEASC",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          }
        },
        "am2": {
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "ser alterado",
            "location": "",
            "kind": "class"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "ser alterado",
            "location": "",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "ser alterado",
            "location": "",
            "kind": "class"
          },
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "ser alterado",
            "location": "",
            "kind": "class"
          }
        },
        "pm1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "2": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Gláucia",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Alexandre",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Jaílson",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luiza A",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Gláucia",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Alexandre",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Jaílson",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luiza A",
            "location": "105",
            "kind": "gt"
          }
        }
      }
    },
    "C": {
      "1": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Juliana H",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Juliana H",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rafael Lopes",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rafael Lopes",
            "location": "Simulação",
            "kind": "th"
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camila B",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Patricia S",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luisa",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Débora",
            "location": "105",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camila B",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Patricia S",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luisa",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Débora",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luiz",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Alexandre",
            "location": "patologia",
            "kind": "pl"
          }
        },
        "am2": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luiz",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Alexandre",
            "location": "patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "",
            "kind": "pe"
          }
        },
        "pm2": {
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          },
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "alterado",
            "location": "",
            "kind": "class"
          }
        }
      },
      "4": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camila B",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Patricia S",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luisa",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Débora",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camila B",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Patricia S",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Maria Luisa",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Débora",
            "location": "105",
            "kind": "gt"
          }
        }
      },
      "5": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      }
    }
  }
},
  incompleteBlocks: [2, 3, 4],
  fixedClinics: {
  "1": {
    "A": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "Marina Araújo",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Santa Rosa",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Kátia Bueno",
        "location": "Centrode Saúde Santa Terezinha",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Ewerton Lamounier Jr.",
        "location": "Centrode Saúde Etelvina Carneiro",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 5,
        "period": "pm",
        "code": "AF6",
        "title": "Clínica Médica",
        "professor": "José Ricardo1",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Granjade Freitas",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "José Roberto",
        "location": "Centrode Saúde MG20",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centrode Saúde Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Maria Jussara",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Juliana Heimann",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "Lucas Freitas",
        "location": "Centrode Saúde Novo Aarão Reis",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Centrode Saúde Cachoeirinha",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "2": {
    "A": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "Marina Araújo",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Santa Rosa",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Kátia Bueno",
        "location": "Centrode Saúde Santa Terezinha",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Ewerton Lamounier Jr.",
        "location": "Centrode Saúde Etelvina Carneiro",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 5,
        "period": "pm",
        "code": "AF6",
        "title": "Clínica Médica",
        "professor": "José Ricardo1",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Granjade Freitas",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "José Roberto",
        "location": "Centrode Saúde MG20",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centrode Saúde Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Maria Jussara",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Juliana Heimann",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "Lucas Freitas",
        "location": "Centrode Saúde Novo Aarão Reis",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Centrode Saúde Cachoeirinha",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "3": {
    "A": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "Marina Araújo",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Santa Rosa",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Kátia Bueno",
        "location": "Centrode Saúde Santa Terezinha",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Ewerton Lamounier Jr.",
        "location": "Centrode Saúde Etelvina Carneiro",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 5,
        "period": "pm",
        "code": "AF6",
        "title": "Clínica Médica",
        "professor": "José Ricardo1",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Granjade Freitas",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "José Roberto",
        "location": "Centrode Saúde MG20",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centrode Saúde Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Maria Jussara",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Juliana Heimann",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "Lucas Freitas",
        "location": "Centrode Saúde Novo Aarão Reis",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Centrode Saúde Cachoeirinha",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "4": {
    "A": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "Marina Araújo",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Santa Rosa",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Kátia Bueno",
        "location": "Centrode Saúde Santa Terezinha",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Ewerton Lamounier Jr.",
        "location": "Centrode Saúde Etelvina Carneiro",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 5,
        "period": "pm",
        "code": "AF6",
        "title": "Clínica Médica",
        "professor": "José Ricardo1",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Granjade Freitas",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "José Roberto",
        "location": "Centrode Saúde MG20",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centrode Saúde Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 5,
        "period": "pm",
        "code": "AF1",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 5,
        "period": "pm",
        "code": "AF2",
        "title": "Pediatria",
        "professor": "Maria Jussara",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 5,
        "period": "pm",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Juliana Heimann",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 5,
        "period": "pm",
        "code": "AF4",
        "title": "Clínica Médica",
        "professor": "Lucas Freitas",
        "location": "Centrode Saúde Novo Aarão Reis",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 5,
        "period": "pm",
        "code": "AF5",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Centrode Saúde Cachoeirinha",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  }
},
  specialtyClinics: {
  "pediatricas1": {
    "1": [
      {
        "day": 4,
        "period": "am",
        "code": "AE1 · CAR1",
        "title": "CAR1",
        "professor": "Contrat (Joyce Parreiras )",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE1 · CAR2",
        "title": "CAR2",
        "professor": "Paulo",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE1 · PNM1",
        "title": "PNM1",
        "professor": "Alexandre",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE1 · GEN1",
        "title": "GEN1",
        "professor": "Maria Clara",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE1 · GEN2",
        "title": "GEN2",
        "professor": "Maria Clara",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE1 · PNM2",
        "title": "PNM2",
        "professor": "Alexandre",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "2": [
      {
        "day": 4,
        "period": "am",
        "code": "AE2 · CAR1",
        "title": "CAR1",
        "professor": "Rafaela Cla",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE2 · CAR2",
        "title": "CAR2",
        "professor": "Jordane",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE2 · PNM1",
        "title": "PNM1",
        "professor": "Maria Luiza A",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "am",
        "code": "AE2 · GEN2",
        "title": "GEN2",
        "professor": "Rafael Lopes",
        "location": "---",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE2 · GEN2",
        "title": "GEN2",
        "professor": "Rafael Lopes",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE2 · PNM2",
        "title": "PNM2",
        "professor": "Jaílson",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 4,
        "period": "am",
        "code": "AE3 · CAR1",
        "title": "CAR1",
        "professor": "Ana Carolina",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE3 · CAR2",
        "title": "CAR2",
        "professor": "Ana Carolina",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE3 · GEN1",
        "title": "GEN1",
        "professor": "Morgana",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE3 · GEN1",
        "title": "GEN1",
        "professor": "Morgana",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE3 · PNM1",
        "title": "PNM1",
        "professor": "Thaís",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE3 · PNM2",
        "title": "PNM2",
        "professor": "Marcelo",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "4": [
      {
        "day": 4,
        "period": "am",
        "code": "AE4 · CAR1",
        "title": "CAR1",
        "professor": "Ricardo N",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE4 · CAR2",
        "title": "CAR2",
        "professor": "Contrat (Joyce Parreiras )",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE4 · PNM1",
        "title": "PNM1",
        "professor": "Thaís",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "am",
        "code": "AE4 · GEN1",
        "title": "GEN1",
        "professor": "Isadora B.",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "am",
        "code": "AE4 · GEN2",
        "title": "GEN2",
        "professor": "Isadora B.",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE4 · PNM2",
        "title": "PNM2",
        "professor": "Maria Luiza A",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 5,
        "period": "am",
        "code": "AE5 · CAR2",
        "title": "CAR2",
        "professor": "Contrat (Omar)",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE5 · CAR1",
        "title": "CAR1",
        "professor": "Ricardo N.",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE5 · PNM1",
        "title": "PNM1",
        "professor": "Jaílson",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "am",
        "code": "AE5 · GEN2",
        "title": "GEN2",
        "professor": "Maria Clara",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE5 · GEN1",
        "title": "GEN1",
        "professor": "Izabella Lusvarghi",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE5 · PNM2",
        "title": "PNM2",
        "professor": "Maria Luiza A",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  }
},
  extraCatalog: [],
  sourcePdf
};
export default periodDataset;
